import { ComboboxData, ComboboxItemGroup } from 'ui';

/** Util to check if an item is a group */
const isGroup = (item: ComboboxData[number]): item is ComboboxItemGroup => {
  if (typeof item !== 'object') return false;
  if (typeof item === 'string') return false;
  return 'group' in item;
};

export { isGroup };
